import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";

import EventLogItemExtra from "./EventLogItemExtra";

import { lightOrDark } from "../../../Base/Utilities/LightOrDark";
import {
  eventsWithCustomTranslations,
  ignoreSubkeyEventTypes,
  includeSuccessEventTypes,
  includeOptionField,
} from "../../../Base/Utilities/EventHelpers";

const EventLogItem = (props) => {
  const { event, currentState, intl, extraPlayInfo } = props;

  const { formatMessage } = intl;
  const [team, setTeam] = useState();
  const [player, setPlayer] = useState();
  const [eventKey, setEventKey] = useState();
  const [isPending, setIsPending] = useState();
  const [updatePlayer, setUpdatePlayer] = useState(true);

  const subkeyOverride = ["tipin"];

  useEffect(() => {
    const entity = currentState.entities.find(
      (el) => el.entityId === event.entityId
    );
    setTeam(entity);
    setUpdatePlayer(true);
    let translationkey = "event." + event.eventType;
    if (event.subType) {
      translationkey = !ignoreSubkeyEventTypes.includes(event.eventType)
        ? translationkey + "." + event.subType
        : translationkey;
      translationkey = subkeyOverride.includes(event.subType)
        ? translationkey + "." + event.subType
        : translationkey;
    }

    const includeOptionFieldItem = includeOptionField.find(
      (item) => item.eventType === event.eventType
    );
    if (includeOptionFieldItem) {
      const optionValue = event.options?.[includeOptionFieldItem.optionField];
      if (optionValue) {
        translationkey = translationkey + "." + optionValue;
      }
    }

    const customTranslation = eventsWithCustomTranslations[event.eventType];
    const customTranslationValue = extraPlayInfo[customTranslation];

    if (customTranslationValue) {
      translationkey = `${translationkey}.${customTranslationValue}`;
    }

    if (typeof event.success === "boolean") {
      translationkey = includeSuccessEventTypes.includes(event.eventType)
        ? translationkey + "." + event.success
        : translationkey;
    }

    setEventKey(translationkey);

    // Double Check pending status
    let pending = !!event.pending;
    if (
      currentState.acks &&
      currentState.acks.findIndex((item) => item === event.eventId) > -1
    ) {
      pending = false;
    }
    setIsPending(pending);
    // eslint-disable-next-line
  }, [currentState.updateLog]);

  useEffect(() => {
    if (team && updatePlayer) {
      setPlayer(team.persons.find((el) => el.personId === event.personId));
      setUpdatePlayer(false);
    }
    // eslint-disable-next-line
  }, [team, updatePlayer]);

  if (event.class === "clock" && event.eventType.includes("Card")) {
    return null;
  }

  return (
    <React.Fragment>
      {team && (
        <div className={"log-event pending-" + isPending}>
          <span
            className={"event-bib " + (team && lightOrDark(team.primaryColor))}
            style={
              team && {
                backgroundColor: team.primaryColor,
              }
            }
          >
            {player && player.bib} {!player && " "}
          </span>
          <span>
            {formatMessage({
              id: eventKey,
              defaultMessage: eventKey,
            })}
            <EventLogItemExtra event={event} eventStore={props.eventStore} />
          </span>
        </div>
      )}
      {!team && eventKey && (
        <div className="log-event">
          <span
            className="event-bib"
            style={{
              backgroundColor: "transparent",
            }}
          >
            {!player && " "}
          </span>
          <span>
            {formatMessage({
              id: eventKey,
              defaultMessage: eventKey,
            })}
          </span>
        </div>
      )}
    </React.Fragment>
  );
};

export default injectIntl(EventLogItem);
